import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "./../api/user.api";
import { useWebSocket } from "./websocket.context";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const navigate = useNavigate();
  const { setTokenOnWebsocket, removeTokenOnWebsocket } = useWebSocket();

  const login = useCallback((data) => {
    setUser(data.user);
    setToken(data.token);
    localStorage.setItem("token", data.token);
    navigate("/");
  }, []);

  const logout = useCallback(() => {
    setUser(null);
    setToken("");
    removeTokenOnWebsocket();
    localStorage.removeItem("token");
    navigate("/login");
  }, []);

  useEffect(() => {
    const checkAuth = async () => {
      if (token) {
        await getCurrentUser()
          .then((response) => {
            setUser(response.data);
            setTokenOnWebsocket(token);
            navigate("/");
          })
          .catch(() => {
            logout();
          });
      }
    };
    checkAuth();
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
export const useAuth = () => useContext(AuthContext);
